/**
 * @page 资产相关store
 * @author qingqing.yang
 * @Date 2018/7/2
 */

import { observable, action, configure, makeAutoObservable } from 'mobx';

import { Form } from '_common/components/Form/Form';
import P3_PHOTO from '_common/formSource/kyc/person/P3_PHOTO';
import UTIL from '_common/utils/util';

import getDataSource from '../../okjp/pages/account/edd/personal/formSource';
import eddKycService from '../service/eddKycService';

configure({
  enforceActions: 'always',
});

class eddKycStore {
  constructor(rootStore) {
    makeAutoObservable(this, {
      type: observable,
      status: observable,
      rejectReason: observable,
      personEdd: observable,
      companyEdd: observable,
      eddFiles: observable,
      personalId: observable,
      companyLegalId: observable,
      companyDirectorId: observable,
      getDataSource: action,
      getEddKycInfo: action,
      cleanStatus: action,
      getTemplate: action,
    });

    this.rootStore = rootStore;
  }

  type = 1; // 0个人  1企业
  status = 0;
  rejectReason = '';
  personEdd = [];
  companyEdd = {};

  eddFiles = []; // 个人或企业的edd文件信息
  personalId = ''; // 个人认证时的个人id
  companyLegalId = ''; // 企业认证时的法人id
  companyDirectorId = ''; // 企业认证时的担当者id

  // 开启自动划转
  getDataSource() {
    return UTIL.deepCopy(getDataSource());
  }

  async getEddKycInfo(params) {
    this.rootStore.loadingStore.showLoading();
    const res = await eddKycService.getEddKycInfo(params);
    action(() => {
      if (res.code === 0) {
        if (res.data) {
          const {
            type,
            status,
            rejectReason,
            personEdd,
            companyEdd,
            eddFiles,
            personalId,
            companyLegalId,
            companyDirectorId,
          } = res.data;
          this.type = type;
          this.status = status;
          this.rejectReason = rejectReason;
          this.personEdd = personEdd || [];
          this.companyEdd = companyEdd || [];
          this.eddFiles = eddFiles || [];
          this.personalId = personalId;
          this.companyLegalId = companyLegalId;
          this.companyDirectorId = companyDirectorId;
        }
      } else {
        this.rootStore.loadingStore.showErrorDialog(res.msg);
      }
    })();
    // 下面这里是不是应该要包进action里面或者重新给它整一个runInAction
    this.rootStore.loadingStore.hideLoading();
    return res;
  }

  cleanStatus() {
    // this.status = -1;
  }

  /**
   * 获取个人模板
   * @returns {Array|*|void}
   */
  getTemplate() {
    let template = UTIL.deepCopy(P3_PHOTO());
    template = Form.conversion(template); // 转换为formLine 使用的数据模板
    return template;
  }
}

export default eddKycStore;
